module.exports = __webpack_public_path__ + "static/media/photo10.a35dcd30.jpg";